export const SETTINGS_RETURN_LINK = '/settings/gobi-integration';
export const MAPPING_CONFIGS_RETURN_LINK = '/settings/gobi-integration/mapping-configuration';

export const MAPPING_CONFIGS_RETURN_LABEL_ID = 'ui-gobi-settings.settings';
